import Login from "../../views/Login";
import {authGuard} from "../../auth";
import Clean from "../../layouts/Clean";

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: authGuard,
        meta: { layout: Clean },
    },
    {
        path: '/auth/:provider/callback',
        component: {
            template: '<div class="auth-component"></div>'
        }
    },
]

export default routes.map(route => {
    const meta = {
    }
    return { ...route, meta }
})